module.exports = __webpack_public_path__ + "static/media/RH_PDF_bg.20957168.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/RH_PDF_bg.png
// module id = 771
// module chunks = 10